export const MAX_CUSTOM_RANGE_DAYS = 366

const MS_PER_DAY = 24 * 60 * 60 * 1000

export function validateCustomDateRange ({ dateBegin, dateEnd }) {
  if (!dateBegin || !dateEnd) {
    return { valid: false, error: 'Begin and end dates are required.' }
  }

  const begin = new Date(dateBegin)
  const end = new Date(dateEnd)

  if (end < begin) {
    return { valid: false, error: 'End date cannot be before the begin date.' }
  }

  const spanDays = Math.round((end - begin) / MS_PER_DAY) + 1
  if (spanDays > MAX_CUSTOM_RANGE_DAYS) {
    return { valid: false, error: `Custom Range cannot span more than ${MAX_CUSTOM_RANGE_DAYS} days.` }
  }

  return { valid: true, error: null }
}
